import { RED } from '@easy-lib/constants';
import {
	PortfolioBuyAveragePriceCalculationType,
	PortfolioCalculationType,
	PortfolioTotalValueCalculateType
} from '@easy-lib/modules/settings';
import { Swipeable } from '@easy-lib/modules/swipe';
import { NormalPercentPipe } from '@easy-lib/pipes/normalPercent.pipe';
import { getColorOfSymbolState } from '@easy-lib/tools';
import { IsInt, Min } from 'class-validator';

export const portfolioItemsForExcelExportFields: {
	farsiTitle?: string;
	fieldName?: string;
	value?: any;
}[] = [
	{
		fieldName: 'symbolName',
		farsiTitle: 'نام نماد'
	},
	{
		fieldName: 'persianDate',
		farsiTitle: 'تاریخ آخرین تراکنش/رویداد'
	},
	{
		fieldName: 'asset',
		farsiTitle: 'تعداد دارایی'
	},
	{
		fieldName: 'bonusShareVolume',
		farsiTitle: 'تعداد سهام جایزه'
	},
	{
		fieldName: 'stockRightVolume',
		farsiTitle: 'تعداد حق تقدم'
	},
	{
		fieldName: 'currentValue',
		farsiTitle: 'ارزش فعلی'
	},
	{
		fieldName: 'lastTradedPrice',
		farsiTitle: 'آخرین قیمت'
	},
	{
		fieldName: 'lastTradedPricePercent',
		farsiTitle: 'درصد آخرین قیمت'
	},
	{
		fieldName: 'closingPrice',
		farsiTitle: ' قیمت پایانی'
	},
	{
		fieldName: 'closingPricePercent',
		farsiTitle: 'درصد قیمت پایانی'
	},
	{
		fieldName: 'todayProfit',
		farsiTitle: 'سود و زیان امروز'
	},
	{
		fieldName: 'periodicDPSAmount',
		farsiTitle: 'سود نقدی مجامع در آخرین دوره'
	},
	{
		fieldName: 'lastDPSAmount',
		farsiTitle: 'آخرین سود نقدی مجمع'
	},
	{
		fieldName: 'totalDPSAmount',
		farsiTitle: 'سود نقدی کل مجامع'
	},
	{
		fieldName: 'profitAmount',
		farsiTitle: 'سود/زیان فعلی'
	},
	{
		fieldName: 'profitPercent',
		farsiTitle: 'درصد سود/زیان فعلی'
	},
	{
		fieldName: 'breakevenPoint',
		farsiTitle: 'قیمت سر به سر بر حسب میانگین خرید در آخرین دوره'
	},
	{
		fieldName: 'breakevenWithoutDps',
		farsiTitle: 'قیمت سر به سر  بر حسب میانگین خرید در آخرین دوره تعدیل نشده توسط سود نقدی مجمع'
	},
	{
		fieldName: 'periodicBuyAveragePrice',
		farsiTitle: 'قیمت میانگین خرید در آخرین دوره با لحاظ کارمزد'
	},
	{
		fieldName: 'periodicBuyAveragePriceWithoutDps',
		farsiTitle: 'قیمت میانگین خرید در آخرین دوره تعدیل نشده توسط سود نقدی مجمع با لحاظ کارمزد'
	},
	{
		fieldName: 'totalBuyAveragePrice',
		farsiTitle: 'قیمت میانگین کل خرید با لحاظ کارمزد'
	},
	{
		fieldName: 'totalBuyAveragePriceWithoutDps',
		farsiTitle: 'قیمت میانگین کل خرید تعدیل نشده توسط سود نقدی مجمع با لحاظ کارمزد'
	},
	{
		fieldName: 'periodicBuyAmount',
		farsiTitle: 'ارزش خرید ها در آخرین دوره با لحاظ کارمزد'
	},
	{
		fieldName: 'totalBuyAmount',
		farsiTitle: 'ارزش کل خرید ها با لحاظ کارمزد'
	},
	{
		fieldName: 'periodicSellAveragePrice',
		farsiTitle: 'قیمت میانگین فروش در آخرین دوره با لحاظ کارمزد'
	},
	{
		fieldName: 'totalSellAveragePrice',
		farsiTitle: 'قیمت میانگین کل فروش با لحاظ کارمزد'
	},
	{
		fieldName: 'periodicSellAmount',
		farsiTitle: 'ارزش فروش ها در آخرین دوره با لحاظ کارمزد'
	},
	{
		fieldName: 'totalSellAmount',
		farsiTitle: 'ارزش کل فروش ها با لحاظ کارمزد'
	},
	{
		fieldName: 'periodicBoughtVolume',
		farsiTitle: 'تعداد سهام خریداری شده در آخرین دوره'
	},
	{
		fieldName: 'totalBoughtVolume',
		farsiTitle: 'تعداد کل سهام خریداری شده'
	},
	{
		fieldName: 'periodicSoldVolume',
		farsiTitle: 'تعداد سهام فروخته شده در آخرین دوره'
	},
	{
		fieldName: 'totalSoldVolume',
		farsiTitle: 'تعداد کل سهام فروخته شده'
	},
	{
		fieldName: 'periodicRealizedProfitAndLoss',
		farsiTitle: 'سود/زیان حاصل از فروش سهام در آخرین دوره با لحاظ کارمزد'
	},
	{
		fieldName: 'periodicRealizedProfitAndLossWithoutDps',
		farsiTitle:
			'سود/زیان حاصل از فروش سهام در آخرین دوره با لحاظ کارمزد بر حسب میانگین خرید تعدیل نشده توسط سود نقدی مجمع'
	},
	{
		fieldName: 'totalRealizedProfitAndLoss',
		farsiTitle: 'سود/زیان کل حاصل از فروش سهام با لحاظ کارمزد'
	},
	{
		fieldName: 'totalRealizedProfitAndLossWithoutDps',
		farsiTitle: 'سود/زیان کل حاصل از فروش سهام با لحاظ کارمزد بر حسب میانگین خرید تعدیل نشده توسط سود نقدی مجمع'
	},
	{
		fieldName: 'dailyBuyAveragePrice',
		farsiTitle: 'قیمت میانگین خرید روز با لحاظ کارمزد'
	},
	{
		fieldName: 'dailySellAveragePrice',
		farsiTitle: 'قیمت میانگین فروش روز با لحاظ کارمزد'
	},
	{
		fieldName: 'dailyBoughtVolume',
		farsiTitle: 'تعداد سهام خریداری شده در روز'
	},
	{
		fieldName: 'dailySoldVolume',
		farsiTitle: 'تعداد سهام فروخته شده در روز'
	},
	{
		fieldName: 'title',
		farsiTitle: 'توضیح نماد'
	}
];

export class IPortfolioItem {
	symbolIsin?: string;
	symbolName?: string;
	title?: string;
	manner?: string;
	isCaution?: string;
	persianDate?: number;
	@IsInt()
	@Min(0)
	asset?: number;
	date?: string;
	bonusShareVolume?: number;
	stockRightVolume?: number;
	periodicDPSAmount?: number;
	lastDPSAmount?: number;
	totalDPSAmount?: number;
	breakevenPoint?: number;
	breakevenWithoutDps?: number;
	periodicBuyAveragePrice?: number;
	periodicBuyAveragePriceWithoutDps?: number;
	totalBuyAveragePrice?: number;
	totalSellAveragePrice?: number;
	totalBuyAveragePriceWithoutDps?: number;
	periodicBuyAmount?: number;
	totalBuyAmount?: number;
	periodicSellAveragePrice?: number;
	periodicSellAmount?: number;
	totalSellAmount?: number;
	periodicBoughtVolume?: number;
	totalBoughtVolume?: number;
	periodicSoldVolume?: number;
	totalSoldVolume?: number;
	periodicRealizedProfitAndLoss?: number;
	periodicRealizedProfitAndLossWithoutDps?: number;
	totalRealizedProfitAndLoss?: number;
	totalRealizedProfitAndLossWithoutDps?: number;
	calculationVersion?: string;
	dailyBuyAveragePrice?: number;
	dailySellAveragePrice?: number;
	dailyBoughtVolume?: number;
	dailySoldVolume?: number;
	portfolioPercent?: number;

	//#region setting
	portfolioTotalValueCalculateType?: PortfolioTotalValueCalculateType;
	portfolioBuyAveragePriceCalculationType?: PortfolioBuyAveragePriceCalculationType;
	portfolioCalculationType?: PortfolioCalculationType;
	//#endregion setting

	//#region marketData
	totalNumberOfSharesTraded?: number;
	lastTradedPrice?: number;
	closingPrice?: number;
	lastTradedPricePercent?: number;
	feeOfPreviousDaysClosingPrice?: number;
	stateCode?: string;
	//#endregion marketData

	//#region symbolInfo
	canBuy?: boolean;
	canSell?: boolean;
	buyCommission?: number;
	sellCommission?: number;
	//#endregion symbolInfo

	isMarketOpen?: boolean;

	lsUpdatedTimestamp?: number;

	swipeState?: Swipeable;
}
export class PortfolioItemsWithCalculation extends IPortfolioItem {
	constructor(obj) {
		super();
		Object.assign(this, obj);
	}
	get assetBuyValue() {
		return (
			this.asset *
			(this.portfolioBuyAveragePriceCalculationType === PortfolioBuyAveragePriceCalculationType.WithDPS
				? this.periodicBuyAveragePrice
				: this.periodicBuyAveragePriceWithoutDps)
		);
	}

	get BonusShareBuyValue() {
		return (
			this.bonusShareVolume *
			(this.portfolioBuyAveragePriceCalculationType === PortfolioBuyAveragePriceCalculationType.WithDPS
				? this.periodicBuyAveragePrice
				: this.periodicBuyAveragePriceWithoutDps)
		);
	}
	get currentValue() {
		let mainFactor = 0;
		if (!(this.closingPrice || this.lastTradedPrice || this.sellCommission)) return 0;
		else if (getColorOfSymbolState(this.stateCode) === RED) {
			mainFactor = this.closingPrice;
		} else if (this.portfolioTotalValueCalculateType === PortfolioTotalValueCalculateType.ClosePrice) {
			mainFactor = this.closingPrice;
		} else if (this.portfolioTotalValueCalculateType === PortfolioTotalValueCalculateType.LastTradedPrice) {
			mainFactor = this.lastTradedPrice;
		} else if (this.portfolioTotalValueCalculateType === PortfolioTotalValueCalculateType.Automatic) {
			mainFactor =
				this.isMarketOpen && this.totalNumberOfSharesTraded !== 0 ? this.lastTradedPrice : this.closingPrice;
		}
		return this.asset * mainFactor * (1 - (this.sellCommission ?? 0));
	}
	get currentBonusShareValue() {
		let mainFactor = 0;
		if (!(this.bonusShareVolume === 0 || this.closingPrice || this.lastTradedPrice || this.sellCommission))
			return 0;
		else if (this.stateColor === RED) {
			mainFactor = this.closingPrice;
		} else if (this.portfolioTotalValueCalculateType === PortfolioTotalValueCalculateType.ClosePrice) {
			mainFactor = this.closingPrice;
		} else if (this.portfolioTotalValueCalculateType === PortfolioTotalValueCalculateType.LastTradedPrice) {
			mainFactor = this.lastTradedPrice;
		} else if (this.portfolioTotalValueCalculateType === PortfolioTotalValueCalculateType.Automatic) {
			mainFactor = this.isMarketOpen ? this.lastTradedPrice : this.closingPrice;
		}
		return this.bonusShareVolume * mainFactor * (1 - (this.sellCommission ?? 0));
	}
	get profitAmount() {
		return this.currentValue - this.assetBuyValue;
	}
	get profitPercent() {
		return this.assetBuyValue
			? new NormalPercentPipe().transform(((this.currentValue - this.assetBuyValue) / this.assetBuyValue) * 100)
			: 0;
	}
	get bonusShareProfitAmount() {
		return this.currentBonusShareValue - this.BonusShareBuyValue;
	}
	get bonusShareProfitPercent() {
		return this.BonusShareBuyValue
			? new NormalPercentPipe().transform(
					((this.currentBonusShareValue - this.BonusShareBuyValue) / this.BonusShareBuyValue) * 100
				)
			: 0;
	}
	get calculatedBreakEvenPoint() {
		return this.portfolioBuyAveragePriceCalculationType === PortfolioBuyAveragePriceCalculationType.WithDPS
			? this.breakevenPoint
			: this.breakevenWithoutDps;
	}
	get realTimePrice() {
		if (getColorOfSymbolState(this.stateCode) === RED && this.totalNumberOfSharesTraded === 0) {
			return this?.closingPrice;
		} else if (this.portfolioTotalValueCalculateType === PortfolioTotalValueCalculateType.ClosePrice) {
			return this?.closingPrice;
		} else if (this.portfolioTotalValueCalculateType === PortfolioTotalValueCalculateType.LastTradedPrice) {
			return this?.lastTradedPrice;
		} else if (this.portfolioTotalValueCalculateType === PortfolioTotalValueCalculateType.Automatic) {
			return this.isMarketOpen ? this?.lastTradedPrice : this?.closingPrice;
		}
	}
	get realTimePricePercent() {
		if (getColorOfSymbolState(this.stateCode) === RED && this.totalNumberOfSharesTraded === 0) {
			return this?.closingPricePercent;
		} else if (this.portfolioTotalValueCalculateType === PortfolioTotalValueCalculateType.ClosePrice) {
			return this?.closingPricePercent;
		} else if (this.portfolioTotalValueCalculateType === PortfolioTotalValueCalculateType.LastTradedPrice) {
			return this?.lastTradedPricePercent;
		} else if (this.portfolioTotalValueCalculateType === PortfolioTotalValueCalculateType.Automatic) {
			return this.isMarketOpen ? this?.lastTradedPricePercent : this?.closingPricePercent;
		}
	}
	get soldProfit() {
		let fieldName = '';
		const postFix =
			this.portfolioBuyAveragePriceCalculationType === PortfolioBuyAveragePriceCalculationType.WithOutDPS
				? 'WithoutDps'
				: '';

		// if (this.portfolioCalculationType === PortfolioCalculationType.Periodic) {
		// 	fieldName = `periodicRealizedProfitAndLoss${postFix}`;
		// } else {
		fieldName = `totalRealizedProfitAndLoss${postFix}`;
		// }

		return this[fieldName];
	}
	get yesterdayAsset() {
		return this.asset - ((this.dailyBoughtVolume ?? 0) - (this.dailySoldVolume ?? 0)) + this.bonusShareVolume;
	}
	get todayProfit() {
		let price = 0;
		if (!this.totalNumberOfSharesTraded || this.totalNumberOfSharesTraded === 0) return 0;
		if (getColorOfSymbolState(this.stateCode) === RED) {
			price = this?.closingPrice;
		} else if (this.portfolioTotalValueCalculateType === PortfolioTotalValueCalculateType.ClosePrice) {
			price = this?.closingPrice;
		} else if (this.portfolioTotalValueCalculateType === PortfolioTotalValueCalculateType.LastTradedPrice) {
			price = this?.lastTradedPrice;
		} else if (this.portfolioTotalValueCalculateType === PortfolioTotalValueCalculateType.Automatic) {
			price = this.isMarketOpen ? this?.lastTradedPrice : this?.closingPrice;
		}

		const buysMinusSells = this.dailyBoughtVolume - this.dailySoldVolume;
		const sellsMinusBuys = this.dailySoldVolume - this.dailyBoughtVolume;
		const isBuyingGreater = buysMinusSells > 0;
		const isSellingGreater = sellsMinusBuys > 0;
		return (
			(isBuyingGreater
				? buysMinusSells * (price * (1 - (this.sellCommission ?? 0)) - this.dailyBuyAveragePrice)
				: 0) +
			(this.yesterdayAsset - (isSellingGreater ? sellsMinusBuys : 0)) *
				(price - this.feeOfPreviousDaysClosingPrice) *
				(1 - (this.sellCommission ?? 0))
		);
	}

	get yesterdayValue() {
		const price = this?.feeOfPreviousDaysClosingPrice;
		return price * this.yesterdayAsset * (1 - this.sellCommission);
	}
	get todayProfitPercent() {
		const buysMinusSells = this.dailyBoughtVolume - this.dailySoldVolume;
		const sellsMinusBuys = this.dailySoldVolume - this.dailyBoughtVolume;
		const isBuyingGreater = buysMinusSells > 0;
		const isSellingGreater = sellsMinusBuys > 0;

		const lastDay =
			// Today Trades
			(isBuyingGreater ? buysMinusSells * (this.dailyBuyAveragePrice * (1 + this.buyCommission)) : 0) +
			// Last days assets minus today sell (if today sell is greater than buy)
			(this.yesterdayAsset - (isSellingGreater ? sellsMinusBuys : 0)) *
				this.feeOfPreviousDaysClosingPrice *
				(1 - this.sellCommission);
		return lastDay ? (this.todayProfit / lastDay) * 100 : this.profitPercent;
	}

	get buyAveragePrice() {
		let fieldName = '';
		const postFix =
			this.portfolioBuyAveragePriceCalculationType === PortfolioBuyAveragePriceCalculationType.WithOutDPS
				? 'WithoutDps'
				: '';

		if (this.portfolioCalculationType === PortfolioCalculationType.Periodic) {
			fieldName = `periodicBuyAveragePrice${postFix}`;
		} else {
			fieldName = `totalBuyAveragePrice${postFix}`;
		}

		return this[fieldName];
	}
	get sellAveragePrice() {
		return this.portfolioCalculationType === PortfolioCalculationType.Periodic
			? this['periodicSellAveragePrice']
			: this['totalSellAveragePrice'];
	}
	get buyAmount() {
		return this.portfolioCalculationType === PortfolioCalculationType.Periodic
			? this['periodicBuyAmount']
			: this['totalBuyAmount'];
	}
	get sellAmount() {
		return this.portfolioCalculationType === PortfolioCalculationType.Periodic
			? this['periodicSellAmount']
			: this['totalSellAmount'];
	}
	get stateColor() {
		return getColorOfSymbolState(this.stateCode);
	}
	get closingPricePercent() {
		return calculateClosingPriceVarPercent(
			this.closingPrice,
			this.feeOfPreviousDaysClosingPrice,
			this.totalNumberOfSharesTraded
		);
	}
}

export const portfolioItemsWithCalculationDefaultValue = {
	portfolioTotalValueCalculateType: PortfolioTotalValueCalculateType.Automatic,
	portfolioBuyAveragePriceCalculationType: PortfolioBuyAveragePriceCalculationType.WithDPS,
	portfolioCalculationType: PortfolioCalculationType.Periodic,
	totalNumberOfSharesTraded: 0,
	lastTradedPricePercent: 0,
	lastTradedPrice: 0,
	closingPrice: 0,
	feeOfPreviousDaysClosingPrice: 0,
	stateCode: null,
	canBuy: false,
	canSell: false,
	buyCommission: 0,
	sellCommission: 0
};
function calculateClosingPriceVarPercent(
	closePrice?: number,
	feeOfPreviousDaysClosingPrice?: number,
	totalNumberOfSharesTraded?: number
): number {
	if (
		feeOfPreviousDaysClosingPrice === 0 ||
		!feeOfPreviousDaysClosingPrice ||
		!totalNumberOfSharesTraded ||
		totalNumberOfSharesTraded === 0
	)
		return 0;

	if (closePrice > 0 && feeOfPreviousDaysClosingPrice > 0)
		return Math.round(((closePrice - feeOfPreviousDaysClosingPrice) / feeOfPreviousDaysClosingPrice) * 10000) / 100;
	return 0;
}
